import { Tag } from "lucide-react";
import { fileUrl } from "@/lib/api";
import { money, vigenciaText } from "@/lib/oferta";

export function OfertaSection({ unit }) {
  const o = unit.oferta;
  if (!unit.oferta_vigente || !o) return null;
  const lista = o.precio_lista ?? unit.precio;
  const showStrike = o.precio_oferta != null && lista != null && Number(lista) > Number(o.precio_oferta);
  const vig = vigenciaText(o);
  return (
    <section className="mt-6 overflow-hidden rounded-sm border-2 border-[#C4674F] bg-[#C4674F]/5" data-testid="detail-oferta">
      <div className="flex items-center gap-2 bg-[#C4674F] px-4 py-2 text-white">
        <Tag size={14} /><p className="mono text-[11px] uppercase tracking-widest">Oferta comercial</p>
      </div>
      {o.imagen && <img src={fileUrl(o.imagen)} alt={o.titulo || "Oferta"} className="max-h-[420px] w-full object-contain bg-white" data-testid="detail-oferta-imagen" />}
      <div className="p-4 md:p-5">
        {o.titulo && <h2 className="font-serif text-2xl leading-tight text-[#3E5641]" data-testid="detail-oferta-titulo">{o.titulo}</h2>}
        {(o.precio_oferta != null || lista != null) && (
          <div className="mt-3 flex flex-wrap items-baseline gap-x-3 gap-y-1">
            {o.precio_oferta != null && <span className="mono text-3xl text-[#C4674F]" data-testid="detail-oferta-precio">{money(o.precio_oferta)}</span>}
            {showStrike && <span className="mono text-base text-[#6B7678] line-through" data-testid="detail-oferta-precio-lista">{money(lista)}</span>}
          </div>
        )}
        {(o.mensualidad_desde != null || o.enganche_desde != null) && (
          <div className="mt-3 grid grid-cols-2 gap-3 text-sm">
            {o.mensualidad_desde != null && <div><p className="text-xs text-[#6B7678]">Mensualidad desde</p><p className="mono text-[#3E5641]" data-testid="detail-oferta-mensualidad">{money(o.mensualidad_desde)}</p></div>}
            {o.enganche_desde != null && <div><p className="text-xs text-[#6B7678]">Enganche desde</p><p className="mono text-[#3E5641]" data-testid="detail-oferta-enganche">{money(o.enganche_desde)}</p></div>}
          </div>
        )}
        {o.descripcion_html && <div className="rich-text mt-4 text-sm text-[#3E5641]" data-testid="detail-oferta-descripcion" dangerouslySetInnerHTML={{ __html: o.descripcion_html }} />}
        {(vig || o.condiciones) && (
          <div className="mt-4 border-t border-[#C4674F]/30 pt-3 text-xs text-[#6B7678]">
            {vig && <p className="font-medium text-[#3E5641]" data-testid="detail-oferta-vigencia">{vig}</p>}
            {o.condiciones && <p className="mt-1 whitespace-pre-line" data-testid="detail-oferta-condiciones">{o.condiciones}</p>}
          </div>
        )}
      </div>
    </section>
  );
}
